//Action Types
import { MERCHANT_DETAILS_URL, CHECK_CART_ITEMS } from '../../util/urls';
import { TEXT_OPENING_SHORTLY } from '../../util/Constants';
import { API_ERROR } from '../../lib/helper';
import moment from 'moment';
import axios from 'axios';
import { map } from 'lodash';
export const HIDE_ORDER_TYPE_POPUP = 'HIDE_ORDER_TYPE_POPUP';
export const LOCATION_DETAILS = 'LOCATION_DETAILS';
export const UPDATE_LOCATION_DETAILS = 'UPDATE_LOCATION_DETAILS';
export const MODE_OF_ORDER = 'MODE_OF_ORDER';
export const DELIVERY_PLACE_CHANGE = 'DELIVERY_PLACE_CHANGE';
export const ADD_TO_BAG = 'ADD_TO_BAG';
export const ADD_TO_BAG_CACHE = 'ADD_TO_BAG_CACHE';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const GO_TO_CHECKOUT = 'GO_TO_CHECKOUT';
export const DELIVERY_DETAILS = 'DELIVERY_DETAILS';
export const MERCHANT_DETAILS = 'MERCHANT_DETAILS';
export const ORDER_DATE = 'ORDER_DATE';
export const ORDER_TIME = 'ORDER_TIME';
export const UPDATE_TIP_PRICE = 'UPDATE_TIP_PRICE';
export const SHOW_MOBILE_SIDEBAR = 'SHOW_MOBILE_SIDEBAR';
export const MERCHANT_DATA_NAME = 'MERCHANT_DATA_NAME';
export const UPDATE_ORDER_ID_DATA = 'UPDATE_ORDER_ID_DATA';
export const RESET_DATA = 'RESET_DATA';
export const LOCATION_CHANGED = 'LOCATION_CHANGED';
export const ROUTE = 'ROUTE';
export const RESET_DASHBOARD = 'RESET_DASHBOARD';
export const CHECKOUT_DINING_CHANGED = 'CHECKOUT_DINING_CHANGED';
export const RESET_CHECKOUT_DINING_CHANGED = 'RESET_CHECKOUT_DINING_CHANGED';
export const SET_ORDER_TYPE_POPUP_ON_ADD_TO_CART =
  'SET_ORDER_TYPE_POPUP_ON_ADD_TO_CART';
export const UNSET_ORDER_TYPE_POPUP_ON_ADD_TO_CART =
  'UNSET_ORDER_TYPE_POPUP_ON_ADD_TO_CART';
export const REORDER_ITEMS = 'REORDER_ITEMS';
export const REORDER_TEMPCART_ITEMS = 'REORDER_TEMPCART_ITEMS';
export const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
export const REFER_LAVUTOGO_DATANAME = 'REFER_LAVUTOGO_DATANAME';
export const LIST_OF_RESTAURANT = 'LIST_OF_RESTAURANT';
export const REFRESH_TAX_DETAILS = 'REFRESH_TAX_DETAILS';
export const RESTORE_TAX_DETAILS = 'RESTORE_TAX_DETAILS';
export const SET_ORDER_TIME_VALIDATION_STATE =
  'SET_ORDER_TIME_VALIDATION_STATE';
export const RELOAD_STORE = 'RELOAD_STORE';
export const UPDATE_CART = 'UPDATE_CART';
export const RESET_POST_CHECKOUT = 'RESET_POST_CHECKOUT';
export const PAYMENT_MODE = 'PAYMENT_MODE';
export const SET_USER_LOCATION = 'SET_USER_LOCATION';
export const SET_USER__SELECTEDLOCATION = 'SET_USER__SELECTEDLOCATION';
export const UPDATING_TAX = 'UPDATING_TAX';
export const ADD_TO_TEMP_CART = 'ADD_TO_TEMP_CART';
export const REORDER_REDIRECTION = 'REORDER_REDIRECTION';

export const SHOW_ORDER_PANEL = 'SHOW_ORDER_PANEL_SIDEBAR';

export const showOrderPanel = show => {
  return {
    type: SHOW_ORDER_PANEL,
    show,
  };
};

export const addToTempCart = (payload, openOrderType) => {
  return {
    type: ADD_TO_TEMP_CART,
    payload,
  };
};

export const setUserLocation = payload => {
  return {
    type: SET_USER_LOCATION,
    payload: payload,
  };
};

export const setLocationSelected = payload => {
  return {
    type: SET_USER__SELECTEDLOCATION,
    payload: payload,
  };
};

export function setPaymentModeDashboard(mode) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: PAYMENT_MODE,
        mode: mode,
      });
      resolve();
    });
  };
}

export function resetPostCheckout() {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: RESET_POST_CHECKOUT,
      });
      resolve();
    });
  };
}

export function setOrderTimeIsValidState(bool) {
  return {
    type: SET_ORDER_TIME_VALIDATION_STATE,
    payload: bool,
  };
}

export function restoreTaxDetails(data) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: RESTORE_TAX_DETAILS,
      });
      resolve();
    });
  };
}

export function refreshTaxDetails(data, doNotEdit) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: REFRESH_TAX_DETAILS,
        data: data,
        doNotEdit: doNotEdit,
      });
      resolve();
    });
  };
}

export function setListOfRestaurant(data) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: LIST_OF_RESTAURANT,
        data: data,
      });
      resolve();
    });
  };
}

export function setLavutogoRefereName(refereName, reset, lavuTogoName) {
  reset = reset || false;
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: REFER_LAVUTOGO_DATANAME,
        refereName: refereName,
        lavuTogoName: lavuTogoName,
        reset: reset,
      });
      resolve();
    });
  };
}

export function resetCheckoutDiningChanged() {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: RESET_CHECKOUT_DINING_CHANGED,
      });
      resolve();
    });
  };
}

export function checkoutDiningChanged() {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: CHECKOUT_DINING_CHANGED,
      });
      resolve();
    });
  };
}

export function setRoute(previousRoute) {
  return {
    type: ROUTE,
    previousRoute: previousRoute,
  };
}

export function locationChanged(obj) {
  return {
    type: LOCATION_CHANGED,
    data: obj,
  };
}

//Export Actions
export function hideOrderTypePopup(mode) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: HIDE_ORDER_TYPE_POPUP,
      });
      resolve();
    });
  };
}

export function locationDetails(obj) {
  return {
    type: LOCATION_DETAILS,
    data: obj,
  };
}

export function updateLocationDetails(data) {
  return {
    type: UPDATE_LOCATION_DETAILS,
    data: data,
  };
}

export function modeOfOrder(mode) {
  return {
    type: MODE_OF_ORDER,
    data: mode,
  };
}

export function checkoutDeliveryPlaceChanged(isDeliveryPopuInCheckout) {
  return {
    type: DELIVERY_PLACE_CHANGE,
    data: isDeliveryPopuInCheckout,
  };
}
export function addItemToBagCache(item) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: ADD_TO_BAG_CACHE,
        data: item,
      });
      resolve(item.orderItemsList);
    });
  };
}
export function addItemToBag(
  item,
  totalCartPrice,
  itemCount,
  updateCurrentItem
) {
  let noOfItems;
  if (updateCurrentItem) {
    noOfItems = itemCount - 1;
  } else {
    noOfItems = itemCount;
  }
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: ADD_TO_BAG,
        data: item,
        totalCartPrice: totalCartPrice,
        numberOfItemsInCart: noOfItems,
        updateCartCount: updateCurrentItem,
      });
      resolve(item);
    });
  };
}

export function removeItemFromBag(items, totalCartPrice, clearOrderId) {
  if (!clearOrderId) {
    clearOrderId = false;
  } else {
    clearOrderId = true;
  }
  localStorage.removeItem('dashboard');
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: REMOVE_ITEM,
        data: items,
        totalCartPrice: totalCartPrice,
        numberOfItemsInCart: items.length,
        emptyCart: Number(items.length) === 0 ? true : false,
        clearOrderId: clearOrderId,
      });
      resolve(items);
    });
  };
}

export function emptyCart() {
  localStorage.removeItem('dashboard');
  return {
    type: REMOVE_ITEM,
    data: [],
    totalCartPrice: 0,
    numberOfItemsInCart: 0,
    emptyCart: true,
  };
}

export function resetDashboard(restsetOrderType = true) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: RESET_DASHBOARD,
        restsetOrderType: restsetOrderType,
      });
      dispatch(emptyCart());
      resolve();
    });
  };
}

export function goToCheckout(addToCartResp) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: GO_TO_CHECKOUT,
        data: addToCartResp,
      });
      resolve();
    });
  };
}

export function deliveryDetails(obj) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: DELIVERY_DETAILS,
        data: obj,
      });
      resolve();
    });
  };
}

export function merchantDetails(obj) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: MERCHANT_DETAILS,
        data: obj,
      });
      resolve();
    });
  };
}
export function merchantDataName(obj) {
  return {
    type: MERCHANT_DATA_NAME,
    data: obj.dataname,
    restaurantContactInformation: obj,
  };
}

export function orderDate(orderDate, orderTime = 0) {
  return {
    type: ORDER_DATE,
    orderDate,
    orderTime,
  };
}

export function orderTime(time) {
  return {
    type: ORDER_TIME,
    orderTime: time,
  };
}

export function reOrderItem(item, taxDetails, orderItemsArray) {
  let tax = {
    taxdetails: taxDetails,
  };
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: REORDER_ITEMS,
        data: item,
        taxDetails: tax,
        reOrderItemsData: orderItemsArray,
      });
      resolve();
    });
  };
}

export function reOrderTempCart(item) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: REORDER_TEMPCART_ITEMS,
        data: item,
      });
      resolve();
    });
  };
}

export function updateTipPrice(tipPrice, tipType, tipPercent) {
  return {
    type: UPDATE_TIP_PRICE,
    tipPrice: tipPrice,
    tipType: tipType,
    tipPercent: tipPercent,
  };
}

export function showMobileSidebar(status) {
  return {
    type: SHOW_MOBILE_SIDEBAR,
    status,
  };
}

export function updateOrderIdDetails(orderIdDetails) {
  return {
    type: UPDATE_ORDER_ID_DATA,
    orderIdDetails: orderIdDetails,
  };
}

export function resetData() {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: RESET_DATA,
      });
      dispatch(emptyCart());
      resolve();
    });
  };
}

export function setOrderTypePopupOnAddToCart() {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: SET_ORDER_TYPE_POPUP_ON_ADD_TO_CART,
      });
      resolve();
    });
  };
}

export function unsetOrderTypePopupOnAddToCart() {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: UNSET_ORDER_TYPE_POPUP_ON_ADD_TO_CART,
      });
      resolve();
    });
  };
}

export function reloadStore(bool) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: RELOAD_STORE,
        payload: bool,
      });
      resolve();
    });
  };
}

export function setReOrderRedirection(bool) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: REORDER_REDIRECTION,
        payload: bool,
      });
      resolve();
    });
  };
}

export function updateCart(cartItems) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: UPDATE_CART,
        payload: cartItems,
      });
      resolve();
    });
  };
}

export function updatingTax(status) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: UPDATING_TAX,
        status: status,
      });
      resolve();
    });
  };
}

export function getWeekDaysConfiguration(params) {
  return new Promise(resolve => {
    fetch(
      MERCHANT_DETAILS_URL +
        'tokenId/' +
        params.tokenId +
        '/dataname/' +
        params.dataname,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Basic ' + btoa(params.jwt),
        },
      }
    )
      .catch(error => {
        API_ERROR(error);
      })
      .then(res => res.json())
      .then(mData => {
        if (mData.DataResponse && mData.DataResponse.ltg_start_end_time) {
          resolve(JSON.parse(mData.DataResponse.ltg_start_end_time));
        } else {
          resolve(false);
        }
      });
  });
}

export function checkCartItemsAvailable(orderItems, props) {
  return new Promise((resolve, reject) => {
    let postData = {
      dataname: props.dashboardData.dataName,
      item_contents: encodeURIComponent(JSON.stringify(orderItems)),
    };
    let config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + btoa(props.jwt),
      },
    };
    return axios
      .post(CHECK_CART_ITEMS + 'tokenId/' + props.tokenId, postData, config)
      .then(function(response) {
        let outOfStockItem = false;
        map(response.data.DataResponse, function(value, key) {
          map(value, function(innerValue, innerKey) {
            if (innerValue.status === 'OutStock') {
              value[0].image = decodeURIComponent(value[0].image);
              outOfStockItem = value;
            }
          });
        });
        resolve(outOfStockItem);
      });
  });
}

export function parseStartTimeEndTime(configuration, date) {
  configuration = configuration[weekDays[new Date(date).getDay()]];
  for (let configKey in configuration) {
    if (
      configuration[configKey] &&
      configuration[configKey].starttime &&
      configuration[configKey].endtime
    ) {
      configuration[configKey].starttime = convertTime(
        configuration[configKey].starttime
      );
      configuration[configKey].endtime = convertTime(
        configuration[configKey].endtime,
        true
      );
    } else {
      configuration = false;
    }
  }

  return configuration;
}

/*
* convertTime from 12 hours to 24 hours
*/
export const convertTime = (time, isEndTime, returnObject) => {
  const timeConvertor = {
    time: time.replace(/ /g, ''),
    isEndTime,
    returnObject: returnObject === true ? true : false,
    timeString: '',
    hours: 0,
    minutes: 0,
    setTime: function() {
      this.time = this.time.toLowerCase();
      this.hours = parseInt(this.time.substr(0, 2));
      if (this.time.indexOf('am') !== -1 && this.hours === 12) {
        this.time = this.time.replace('12', '24');
      }
      if (this.time.indexOf('pm') !== -1 && this.hours < 12) {
        this.time = this.time.replace(this.hours, this.hours + 12);
      }

      this.time = this.time.replace(/(am|pm)/, '');
      const timeSplit = this.time.split(':');
      this.hours =
        timeSplit[0].length > 2 && Number(timeSplit[0][0]) === 0
          ? parseInt(timeSplit[0], 10)
          : timeSplit[0];
      this.minutes = timeSplit[1];
      this.timeString = this.hours + ':' + this.minutes;
    },
    getTime: function() {
      return this.returnObject
        ? { hours: this.hours, minutes: this.minutes, modifier: this.modifier }
        : this.hours + ':' + this.minutes;
    },
  };

  timeConvertor.setTime();
  return timeConvertor.getTime();
};

export function roundUpMins(m) {
  let flag = 0;
  while (flag === 0) {
    if (m % 1 !== 0) {
      m++;
    } else {
      flag = 1;
      return m;
    }
  }
}

export function getTimings(
  minimumNoticeTime,
  selectedDate,
  startTime,
  endTime,
  checkForAvailability,
  isNextDay
) {
  const timeConfig = {
    minimumNoticeTime: Number(minimumNoticeTime),
    startTime: startTime.split(':'),
    startTimeInMinutes: 0,
    endTimeInMinutes: 0,
    endTime: endTime.split(':'),
    timeInterval: 5,
    checkForAvailability: checkForAvailability,
    atMoment: moment(),
    atSelect: moment(selectedDate),
    list: [],
    counter: 0,
    isNowAvailable: false,
    isNextDay,
    currentTimeInMinuters: moment().get('hours') * 60 + moment().get('minutes'),
    setSE_TimesInMinutes: function() {
      if (Number(this.startTime[0]) === 24) {
        this.startTime[0] = 0;
      }
      this.startTimeInMinutes =
        Number(this.startTime[0]) * 60 + Number(this.startTime[1]);
      this.endTimeInMinutes =
        Number(this.endTime[0]) * 60 + Number(this.endTime[1]);
    },
    isCurrentDate: function() {
      return (
        this.atMoment.format('MM-DD-YYYY') ===
        this.atSelect.format('MM-DD-YYYY')
      );
    },
    getTimeList: function() {
      this.setSE_TimesInMinutes();
      if (this.isCurrentDate()) {
        var d = new Date();
        this.atMoment.set('minute', roundUpMins(this.atMoment.get('minutes')));
        this.atMoment.add(this.minimumNoticeTime, 'minutes');
        if (
          this.currentTimeInMinuters > this.startTimeInMinutes &&
          checkForAvailability === true
        ) {
          this.startTimeInMinutes = roundUpMins(
            this.atMoment.get('hours') * 60 + this.atMoment.get('minutes')
          );
          this.isNowAvailable = this.startTimeInMinutes < this.endTimeInMinutes;
        } else if (
          this.isNextDay === true &&
          this.startTimeInMinutes > this.currentTimeInMinuters
        ) {
          this.isNowAvailable = TEXT_OPENING_SHORTLY;
        }

        if (!this.isNowAvailable) {
          if (this.currentTimeInMinuters < this.startTimeInMinutes) {
            this.atMoment.set('hours', this.startTime[0]);
            this.atMoment.set('minute', this.startTime[1]);
            this.atMoment.set(
              'minute',
              roundUpMins(this.atMoment.get('minutes'))
            );
          }
          this.startTimeInMinutes = roundUpMins(
            this.atMoment.get('hours') * 60 + this.atMoment.get('minutes')
          );

          while (this.startTimeInMinutes <= this.endTimeInMinutes) {
            if (this.counter > 0) {
              this.atMoment.add(this.timeInterval, 'minutes');
            }
            this.list.push({
              hours: this.atMoment.get('hours'),
              minutes: this.atMoment.get('minutes'),
              ampm: this.atMoment.format('A'),
              formattedTime: this.atMoment.format('hh:mm A'),
            });
            this.startTimeInMinutes =
              this.startTimeInMinutes + this.timeInterval;
            this.counter++;
          }
          if (
            this.endTime[1] >= this.endTimeInMinutes % 60 &&
            this.startTimeInMinutes % 60 !== this.endTime[1] &&
            this.startTimeInMinutes % 60 !== this.endTimeInMinutes % 60 &&
            this.list[this.list.length - 1]
          ) {
            this.atMoment.add(
              this.endTime[1] - this.list[this.list.length - 1].minutes,
              'minutes'
            );
            this.list.push({
              hours: this.atMoment.get('hours'),
              minutes: this.atMoment.get('minutes'),
              ampm: this.atMoment.format('A'),
              formattedTime: this.atMoment.format('hh:mm A'),
            });
          }
        }
      } else {
        this.atSelect.set('hours', this.startTime[0]);
        this.atSelect.set('minute', this.startTime[1]);
        this.atSelect.set('minute', roundUpMins(this.atSelect.get('minutes')));
        this.list.push({
          hours: this.atSelect.get('hours'),
          minutes: this.atSelect.get('minutes'),
          ampm: this.atSelect.format('A'),
          formattedTime: this.atSelect.format('hh:mm A'),
        });
        while (this.startTimeInMinutes < this.endTimeInMinutes) {
          this.atSelect.add(this.timeInterval, 'minutes');
          this.list.push({
            hours: this.atSelect.get('hours'),
            minutes: this.atSelect.get('minutes'),
            ampm: this.atSelect.format('A'),
            formattedTime: this.atSelect.format('hh:mm A'),
          });
          this.startTimeInMinutes = this.startTimeInMinutes + this.timeInterval;
        }
        if (this.endTime[1] > this.list[this.list.length - 1].minutes) {
          this.atMoment.add(
            this.endTime[1] - this.list[this.list.length - 1].minutes,
            'minutes'
          );
          this.list.push({
            hours: this.atMoment.get('hours'),
            minutes: this.atMoment.get('minutes'),
            ampm: this.atMoment.format('A'),
            formattedTime: this.atMoment.format('hh:mm A'),
          });
        }
        if (this.endTime[1] < this.list[this.list.length - 1].minutes) {
          this.atSelect.set('hours', this.list[this.list.length - 2].hours);
          this.atSelect.set('minute', this.list[this.list.length - 2].minutes);
          if (this.endTime[1] === '00') {
            this.endTime[1] = 60;
          }
          this.atSelect.add(
            parseInt(this.endTime[1]) -
              parseInt(this.list[this.list.length - 2].minutes),
            'minutes'
          );
          this.list.pop();
          this.list.push({
            hours: this.atSelect.get('hours'),
            minutes: this.atSelect.get('minutes'),
            ampm: this.atSelect.format('A'),
            formattedTime: this.atSelect.format('hh:mm A'),
          });
        }
      }
      if (checkForAvailability === true) {
        return this.isNowAvailable;
      } else {
        return this.list;
      }
    },
  };
  return timeConfig.getTimeList();
}



// WEBPACK FOOTER //
// ./src/views/dashboard/actions.js